'use strict';

module.exports = function isEmpty() {
  return !this.items.length;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/isEmpty.js
// module id = 259
// module chunks = 0